const {h, render, Component} = require('preact');
const GrouponValidate = require('../../../../../groupon/frontend/validate')
const IMask = require('imask');

class PhoneNumberInputView extends Component {
    constructor(props) {
        super(props);
        this.isInputCompulsory = true;
        this.state = {};
        this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
        this.focusFormInput = this.focusFormInput.bind(this);
    }

    readInput() {
        return document.getElementById("v2-number-input").value.trim();
    }

    isInputGiven() {
      return document.getElementById("v2-number-input").value.trim().length > 0;
    }

    isInputValid() {
        if (this.validateDescription() == true) {
            return true;
        }
        else {
            return false;
        }
    }

    validatePhoneNumber() {
        var isValid = false;
        if (this.isInputCompulsory &&  this.isInputGiven() && this.isInputValid()) {
            isValid = true;
        }

        this.props.changePhoneBoxState(this.readInput(), isValid);
    }

    validateDescription() {
        return GrouponValidate.phone(this.readInput())
    }

    focusFormInput() {
        var phoneView = document.getElementById("phone-view");
        phoneView.classList.add('focused');
        this.phoneMask = new IMask(document.getElementById("v2-number-input"), {
          mask: '(000)000-0000',
          lazy: false,  // make placeholder always visible
          placeholderChar: '_'     // defaults to '_'
        });
        if (document.getElementById("v2-number-input").value.trim().length > 0) {
            phoneView.classList.add('filled');
        }
    }


    focusOutFormInput() {
      var phoneView = document.getElementById("phone-view");
      phoneView.classList.remove('focused');
      if (document.getElementById("v2-number-input").value.trim().length > 0) {
          phoneView.classList.add('filled')
      }
      else {
        phoneView.classList.remove('filled')
      }
    }

    componentDidMount() {
        this.validatePhoneNumber()
        this.inputEl = document.getElementById("v2-number-input");
        this.inputEl.addEventListener("focusin", this.focusFormInput)
        this.inputEl.addEventListener("focusout", this.focusOutFormInput)
        this.inputEl.addEventListener("keyup", this.validatePhoneNumber)
    }

    componentWillUnmount() {
        this.inputEl.removeEventListener("focusin", this.focusFormInput)
        this.inputEl.removeEventListener("focusout", this.focusOutFormInput)
        this.inputEl.removeEventListener("keyup", this.validatePhoneNumber)
        if (this.phoneMask) {
            this.phoneMask.destroy();
        }
    }

    render() {
        return (
            <div class="form-v2-1">
                <div class="gig-field inputField phone-number-input" id="phone-view">
                    <label for="v2-number-input">{I18n.translate('js.modules.web_2018.phone_number')}
                        <span class="error-message validatePhoneNumberInput invalid-input call-back-option-error initially-hidden" style="display: none;">
                        {I18n.translate('js.modules.support.call_me_back_invalid_phone')}</span>
                    </label>
                    <input class="inputField phone_number_input call-back-inputs call-back-phone-number-input" data-inputmask="'mask': '(999) 999-9999'" size="40" maxlength="250" type="text" label="input phone number" id="v2-number-input" name="contactPhone" data-bhw="call-me-back-option-phone-number" aria-label="Phone" number="" data-bhw-path="call-me-back-option-phone-number"/>
                </div>
            </div>
        )
    }
}

module.exports = PhoneNumberInputView